
var CBaseModel = Backbone.Model.extend({

    sync: function( method, model, options )
    {

        if (typeof this.urls === 'undefined' )
        {
            throw new Error('Model needs to define urls on initialization');
        }

        options.emulateHTTP = true;
        options.contentType = "application/x-www-form-urlencoded; charset=UTF-8";
        options.data = jQuery.param( model.toJSON() );

        switch ( method )
        {
            case 'create':
            case 'update':
                options.url =  this.urls.create;
                break;

            case 'delete':
                options.url =  this.urls.delete;
                break;
        }
        return Backbone.sync(method, model, options);
    },

    /**
     * Pessimistic destroy. Will only complete if our CRESTServer reply says it is OK.
     * @param objOptions
     * @returns {object} xhr for delete operation
     * @see Backbone.Model.prototype.destroy
     */
    tryDestroy: function(objOptions)
    {
        objOptions = objOptions ? _.clone(objOptions) : {};
        var objModel = this;
        var fnSuccess = objOptions.success;

        var fnDestroy = function()
        {
            objModel.stopListening();
            objModel.trigger('destroy', objModel, objModel.collection, objOptions);
        };

        objOptions.success = function(objResponse)
        {
            if (objResponse.status === 'ERROR')
            {
                return mediaBankCore.alertError('Error', objResponse.error, objResponse.showmodaldialog);
            }

            fnDestroy();
            if (fnSuccess) fnSuccess.call(objOptions.context, objModel, objResponse, objOptions);
            if (!objModel.isNew()) objModel.trigger('sync', objModel, objResponse, objOptions);
        };

        var xhr = false;
        if (objModel.isNew())
        {
            _.defer(objOptions.success);
        }
        else
        {
            xhr = objModel.sync('delete', objModel, objOptions);
        }
        return xhr;
    },

    parse : function(response, options)
    {
        if (options.collection)
        {
            return response;
        }
        return response.data;
    },

    areAlphaNumericValues: function(texts)
    {
        var self = this;
        var strInvalidMatch = _.find(texts, function(item){
            return !self.isAlphanumeric(item);
        });
        return (typeof strInvalidMatch === 'undefined');
    },

    isAlphanumeric: function(text)
    {
        var re = /^[a-z0-9-_\såÅøØæÆ]+$/i;

        if (!re.test(text))
        {
            return  false
        }
        return true;
    }

});